import React from "react";
import PropTypes from "prop-types";
import { Form } from "semantic-ui-react";
import { strings } from "../../resources";
import { CheckboxGroup, YesNoInput } from ".";
import {
  skinConditionOptions,
  smokingConditionOptions,
  facialVolumeDetailOptions,
  abnormalConditionOptions,
} from "../../resources/CheckboxOptions";
import "../css/TreatmentComponents.css";

const ExaminationNotesEdit = (props) => {
  const data = props.selectedTreatmentData;

  return (
    <div className="examinationNotes">
      {renderFitzpatrickSkinTypeQuestion()}
      {renderGlogauSkinGroupQuestion()}
      {renderSkinConditionQuestion()}
      {renderSignsOfSmokingQuestion()}
      {renderFacialVolumeQuestion()}
      {renderAbnormalFeaturesQuestion()}
    </div>
  );

  function renderFitzpatrickSkinTypeQuestion() {
    const radioButtonLabels = [
      strings.form.databaseValues.fitzpatrickSkinTypeI,
      strings.form.databaseValues.fitzpatrickSkinTypeII,
      strings.form.databaseValues.fitzpatrickSkinTypeIII,
      strings.form.databaseValues.fitzpatrickSkinTypeIV,
      strings.form.databaseValues.fitzpatrickSkinTypeV,
      strings.form.databaseValues.fitzpatrickSkinTypeVI,
    ];

    return (
      <>
        <Form.Field
          className="textField"
          content={
            <label>
              <span
                className={
                  props.errorFields.includes("examination_fitzpatrick_skin_type")
                    ? "errorLabel"
                    : ""
                }
              >
                {strings.form.label.fitzpatrickSkinTypeHeader}
              </span>
              <span className="requiredAsterisk"> *</span>
            </label>
          }
        />
        <Form.Group inline>
          {radioButtonLabels.map((radioButtonLabel) => {
            return (
              <Form.Radio
                error={props.errorFields.includes("examination_fitzpatrick_skin_type")}
                disabled={props.mode === "view" || props.mode === "template"}
                label={radioButtonLabel}
                name="examination_fitzpatrick_skin_type"
                value={radioButtonLabel}
                checked={
                  data.examination_fitzpatrick_skin_type === radioButtonLabel ||
                  false
                }
                onChange={props.handleChange}
              />
            );
          })}
        </Form.Group>
      </>
    );
  }

  function renderGlogauSkinGroupQuestion() {
    const radioButtonLabels = [
      strings.form.databaseValues.glogauSkinGroup1,
      strings.form.databaseValues.glogauSkinGroup2,
      strings.form.databaseValues.glogauSkinGroup3,
      strings.form.databaseValues.glogauSkinGroup4,
    ];
    return (
      <>
        <Form.Field
          className="textField"
          content={
            <label>
              <span
                className={
                  props.errorFields.includes("examination_glogau_skin_group")
                    ? "errorLabel"
                    : ""
                }
              >
                {strings.form.label.glogauSkinGroupHeader}
              </span>
              <span className="requiredAsterisk"> *</span>
            </label>
          }
        />
        <Form.Group inline>
          {radioButtonLabels.map((radioButtonLabel) => {
            return (
              <Form.Radio
                error={props.errorFields.includes(
                  "examination_glogau_skin_group"
                )}
                disabled={props.mode === "view" || props.mode === "template"}
                label={radioButtonLabel}
                name="examination_glogau_skin_group"
                value={radioButtonLabel}
                checked={
                  data.examination_glogau_skin_group === radioButtonLabel ||
                  false
                }
                onChange={props.handleChange}
              />
            );
          })}
        </Form.Group>
      </>
    );
  }

  function renderSkinConditionQuestion() {
    const radioButtonLabels = [
      strings.form.databaseValues.skinConditionGood,
      strings.form.databaseValues.skinConditionMildDamage,
      strings.form.databaseValues.skinConditionModerateDamage,
      strings.form.databaseValues.skinConditionSevereDamage,
    ];
    return (
      <>
        <Form.Field
          className="textField"
          content={
            <label>
              <span
                className={
                  props.errorFields.includes("examination_skin_condition")
                    ? "errorLabel"
                    : ""
                }
              >
                {strings.form.label.skinConditionHeader}
              </span>
              <span className="requiredAsterisk"> *</span>
            </label>
          }
        />
        <Form.Group inline>
          {radioButtonLabels.map((radioButtonLabel) => {
            return (
              <Form.Radio
                error={props.errorFields.includes("examination_skin_condition")}
                disabled={props.mode === "view" || props.mode === "template"}
                label={radioButtonLabel}
                name="examination_skin_condition"
                value={radioButtonLabel}
                checked={
                  data.examination_skin_condition === radioButtonLabel || false
                }
                onChange={props.handleChange}
              />
            );
          })}
        </Form.Group>
        {(data.examination_skin_condition ===
          strings.form.databaseValues.skinConditionModerateDamage ||
          data.examination_skin_condition ===
            strings.form.databaseValues.skinConditionSevereDamage) && (
          <div className="yesNoChild">
            <CheckboxGroup
              mode={props.mode}
              error={props.errorFields.includes("examination_skin_conditions")}
              label=""
              horizontal
              group="examination_skin_conditions"
              data={data}
              handleCheckboxChange={props.handleCheckboxGroupChange}
              options={skinConditionOptions}
            />
          </div>
        )}
      </>
    );
  }

  function renderSignsOfSmokingQuestion() {
    return (
      <YesNoInput
        mode={props.mode}
        error={props.errorFields.includes("examination_smoking")}
        name="examination_smoking"
        label={strings.form.label.smokingHeader}
        value={data.examination_smoking}
        changehandler={props.handleYesNoChange}
        required
        showChildWhenValue="Yes"
        childrenFields={["examination_smoking_conditions"]}
        childElement={
          <CheckboxGroup
            error={props.errorFields.includes("examination_smoking_conditions")}
            label=""
            horizontal
            mode={props.mode}
            group="examination_smoking_conditions"
            data={data}
            handleCheckboxChange={props.handleCheckboxGroupChange}
            options={smokingConditionOptions}
          />
        }
      />
    );
  }

  function renderFacialVolumeQuestion() {
    const radioButtonLabels = [
      strings.form.databaseValues.facialVolumeGood,
      strings.form.databaseValues.facialVolumeGoodMinimal,
      strings.form.databaseValues.facialVolumeStartedDeteriorating,
      strings.form.databaseValues.facialVolumeDeteriorated,
    ];
    return (
      <>
        <Form.Field
          className="textField"
          content={
            <label>
              <span
                className={
                  props.errorFields.includes("examination_facial_volume")
                    ? "errorLabel"
                    : ""
                }
              >
                {strings.form.label.facialVolumeHeader}
              </span>
              <span className="requiredAsterisk"> *</span>
            </label>
          }
        />

        {radioButtonLabels.map((radioButtonLabel) => {
          return (
            <Form.Group>
              <Form.Radio
                error={props.errorFields.includes("examination_facial_volume")}
                disabled={props.mode === "view" || props.mode === "template"}
                label={radioButtonLabel}
                name="examination_facial_volume"
                value={radioButtonLabel}
                checked={
                  data.examination_facial_volume === radioButtonLabel || false
                }
                onChange={props.handleChange}
              />
            </Form.Group>
          );
        })}

        {(data.examination_facial_volume ===
          strings.form.databaseValues.facialVolumeGoodMinimal ||
          data.examination_facial_volume ===
            strings.form.databaseValues.facialVolumeStartedDeteriorating ||
          data.examination_facial_volume ===
            strings.form.databaseValues.facialVolumeDeteriorated) && (
          <div className="yesNoChild">
            <CheckboxGroup
              error={props.errorFields.includes(
                "examination_facial_volume_details"
              )}
              label=""
              mode={props.mode}
              group="examination_facial_volume_details"
              data={data}
              handleCheckboxChange={props.handleCheckboxGroupChange}
              options={facialVolumeDetailOptions}
            />
          </div>
        )}
      </>
    );
  }

  function renderAbnormalFeaturesQuestion() {
    return (
      <YesNoInput
        mode={props.mode}
        error={props.errorFields.includes("examination_abnormal")}
        name="examination_abnormal"
        label={strings.form.label.abnormalHeader}
        value={data.examination_abnormal}
        changehandler={props.handleYesNoChange}
        required
        showChildWhenValue="Yes"
        childrenFields={["examination_abnormal_conditions"]}
        childElement={
          <CheckboxGroup
            error={props.errorFields.includes(
              "examination_abnormal_conditions"
            )}
            label=""
            mode={props.mode}
            group="examination_abnormal_conditions"
            data={data}
            handleCheckboxChange={props.handleCheckboxGroupChange}
            options={abnormalConditionOptions}
          />
        }
      />
    );
  }
};

ExaminationNotesEdit.protoTypes = {
  mode: PropTypes.string.isRequired,
  selectedTreatmentData: PropTypes.object.isRequired,
  errorFields: PropTypes.array.isRequired,
  handleChange: PropTypes.func.isRequired,
  handleCheckboxGroupChange: PropTypes.func.isRequired,
  handleYesNoChange: PropTypes.func.isRequired,
};

export default ExaminationNotesEdit;
